<template>
  <div class="app-container">
    <div class="main-content">
      <!-- 待排产工单列表 -->
      <div v-show="showAside" class="work-order-list" :style="showAside ?'display: flex;':'display: none'">
        <div class="section-title">
          <i class="el-icon-s-order"/>
          待排产工单列表
        </div>
        <div class="table-container">
          <view-table
              ref="viewTable"
              :columns-property="columnsProperty"
              :filter="filter"
              :auto-load="false"
              row-key="productionOrderId"
              module="basic"
              :table-select="false"
              :table-action="true"
              :max-height-offset="-60"
              url="productionOrderScheduled/list/unScheduled"
              @data-loaded="syncRemainingCount"
              @search="handleRefreshTimeCount"
              @reset="resetHandle">
            <template slot="adSearch">
              <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
                <el-form-item label="计划开始日期">
                  <el-date-picker
                      v-model="filter.productStart"
                      type="date"
                      style="width: 200px"
                      value-format="yyyy-MM-dd"
                      clearable/>
                </el-form-item>
                <el-form-item label="组装排产">
                  <el-select v-model="filter.assemblePlan" clearable>
                    <el-option label="已排" :value="1"/>
                    <el-option label="未排" :value="0"/>
                  </el-select>
                </el-form-item>
                <el-form-item label="测试排产">
                  <el-select v-model="filter.testPlan" clearable>
                    <el-option label="已排" :value="1"/>
                    <el-option label="未排" :value="0"/>
                  </el-select>
                </el-form-item>
                <el-form-item label="发料排产">
                  <el-select v-model="filter.feedPlan" clearable>
                    <el-option label="已排" :value="1"/>
                    <el-option label="未排" :value="0"/>
                  </el-select>
                </el-form-item>
                <el-form-item label="老化排产">
                  <el-select v-model="filter.agingPlan" clearable>
                    <el-option label="已排" :value="1"/>
                    <el-option label="未排" :value="0"/>
                  </el-select>
                </el-form-item>
                <el-form-item label="工单号">
                  <el-input v-model.trim="filter.orders" type="textarea" placeholder="请输入工单编号" clearable/>
                </el-form-item>
                <el-form-item label="物料号">
                  <el-input v-model.trim="filter.materialNo" placeholder="请输入物料编号" clearable/>
                </el-form-item>
                <el-form-item label="物料名称">
                  <el-input v-model.trim="filter.materialDescription" placeholder="请输入物料名称" clearable/>
                </el-form-item>
                <el-form-item label="工单类型">
                  <el-select v-model="filter.orderType" clearable placeholder="请选择工单类型">
                    <el-option label="全部" value=""/>
                    <el-option label="标准生产订单" value="GK01"/>
                    <el-option label="试制生产订单" value="GK02"/>
                    <el-option label="小批生产订单" value="GK03"/>
                    <el-option label="改制生产订单" value="GK04"/>
                    <el-option label="拆解生产订单" value="GK05"/>
                    <el-option label="呆滞拆解订单" value="GK06"/>
                    <el-option label="外购返修订单" value="GK07"/>
                    <el-option label="研发整改订单" value="ZPP8"/>
                  </el-select>
                </el-form-item>
              </el-form>
            </template>
            <template slot="actionBtn" slot-scope="scope">
              <el-button type="primary" @click="addToSchedule(scope.row)">添加</el-button>
            </template>
            <template slot="otherBtn">
              <el-button type="warning" size="small" :loading="timeCountLoading" @click="handleRefreshTimeCount">刷新工时</el-button>
              <span class="remaining-count">当前页剩余条数：{{remainingCount}}</span>
            </template>
          </view-table>
        </div>
      </div>
      <el-button
          v-show="showAside1"
          style="padding: 1px"
          :icon="showAside ? 'el-icon-arrow-left' : 'el-icon-arrow-right'"
          @click="handleCollapse"/>
      <el-button
          v-show="showAside"
          style="padding: 1px"
          :icon="showAside1 ? 'el-icon-arrow-right' : 'el-icon-arrow-left'"
          @click="handleCollapse1"/>
      <!-- 已排产工单 -->
      <div class="work-order-list work-order-right-box" :style="showAside1 ? 'display: flex;' : 'display: none'">
        <div class="section-title">
          <i class="el-icon-s-order"/>
          排产订单列表
        </div>
        <div>
          <div class="schedule-date-header">
            <div class="date-navigation">
              <el-date-picker
                  v-model="currentDate"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="请选择排产日期"
                  style="width: 150px"
                  @change="getData"/>
              <el-select
                  v-model="currentLineId"
                  style="width: 120px"
                  placeholder="请选择产线"
                  @change="handleCurrentLineChange">
                <el-option
                    v-for="item in lineList"
                    :key="item.id"
                    :label="item.lineName"
                    :value="item.id"/>
              </el-select>
              <el-select
                  v-model="currentShiftId"
                  style="width: 120px"
                  placeholder="请选择班次"
                  @change="handleShiftChange">
                <el-option
                    v-for="item in shiftList"
                    :key="item.id"
                    :label="item.shiftName"
                    :value="item.id"/>
              </el-select>
              人数:<el-input
                  v-model="currentPersonNum"
                  style="width: 100px"
                  type="number"
                  min="1"
                  @blur="calculateAllOrderTimes"/>
            </div>
          </div>
          <div class="schedule-toolbar">
            <div>
              <el-button type="primary" size="small" icon="el-icon-search" @click="getData">查询</el-button>
              <el-button
                  :loading="submitLoading"
                  type="success"
                  size="small"
                  icon="el-icon-check"
                  @click="handleSave">
                保存
              </el-button>
              <el-button size="small" icon="el-icon-refresh-right" @click="handleReset">重置</el-button>
            </div>
          </div>
          <div v-loading="scheduleLoading">
            <div class="add-schedule-row">
              <el-button type="success" @click="handleAddSchedule">+ 新增排产</el-button>
              <column-config-tool :el-table="elTableRef" code="productionOrderScheduled/scheduledTable" @refresh="getData"/>
            </div>
            <el-table
                id="dragTable2"
                ref="elTable"
                :max-height="tableHeight"
                row-key="productionOrderId"
                :data="scheduledOrders"
                border
                show-summary
                :summary-method="getSummaries">
              <el-table-column type="index" label="序号" align="center" width="55"/>
              <el-table-column label="工时" align="center" width="85">
                <template v-slot="scope">
                  <el-input
                      v-if="scope.row.isManual"
                      v-model="scope.row.workTime"
                      size="small"
                      type="number"
                      @change="handleWorkTimeChange(scope.row)"/>
                  <span v-else>{{scope.row.workTime}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="startTime" label="开始" align="center" width="60"/>
              <el-table-column prop="endTime" label="结束" align="center" width="60"/>
              <el-table-column prop="productionOrderNo" label="工单号" align="center" width="95">
                <template v-slot="scope">
                  <el-input
                      v-if="scope.row.isManual"
                      v-model="scope.row.productionOrderNo"
                      size="small"
                      placeholder="请输入"/>
                  <span v-else>{{scope.row.productionOrderNo}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="productLayer" label="产品层次" align="center" width="75">
                <template v-slot="scope">
                  <el-input v-if="scope.row.isManual" v-model="scope.row.productLayer" size="small" placeholder="请输入"/>
                  <span v-else>{{scope.row.productLayer}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="addDate" label="下单日期" align="center" width="95">
                <template v-slot="scope">
                  <el-date-picker
                      v-if="scope.row.isManual"
                      v-model="scope.row.addDate"
                      type="date"
                      value-format="yyyy-MM-dd"
                      size="small"
                      style="width:100%"
                      placeholder="选择日期"/>
                  <span v-else>{{scope.row.addDate}}</span>
                </template>
              </el-table-column>
              <el-table-column label="数量" align="center" width="100">
                <template v-slot="scope">
                  <el-input
                      v-model="scope.row.quantity"
                      size="small"
                      type="number"
                      min="0"
                      @change="handleQuantityChange(scope.row)"
                      @blur="handleQuantityChange(scope.row)"
                      @keyup.enter.native="handleQuantityChange(scope.row)"/>
                </template>
              </el-table-column>
              <el-table-column
                  prop="orderTypeName"
                  label="工单类型"
                  align="center"
                  width="85"
                  show-overflow-tooltip>
                <template v-slot="scope">
                  <el-select
                      v-if="scope.row.isManual"
                      v-model="scope.row.orderType"
                      size="small"
                      style="width:100%"
                      placeholder="请选择">
                    <el-option label="GK01" value="GK01"/>
                    <el-option label="GK02" value="GK02"/>
                    <el-option label="GK03" value="GK03"/>
                    <el-option label="GK04" value="GK04"/>
                    <el-option label="GK05" value="GK05"/>
                    <el-option label="GK06" value="GK06"/>
                    <el-option label="GK07" value="GK07"/>
                    <el-option label="ZPP8" value="ZPP8"/>
                  </el-select>
                  <span v-else>{{scope.row.orderTypeName}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="materialNo" label="物料号" align="center" width="95">
                <template v-slot="scope">
                  <el-input v-if="scope.row.isManual" v-model="scope.row.materialNo" size="small" placeholder="请输入"/>
                  <span v-else>{{scope.row.materialNo}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="materialDescription" label="物料名称" min-width="100" show-overflow-tooltip>
                <template v-slot="scope">
                  <el-input
                      v-if="scope.row.isManual"
                      v-model="scope.row.materialDescription"
                      size="small"
                      placeholder="请输入"/>
                  <span v-else>{{scope.row.materialDescription}}</span>
                </template>
              </el-table-column>
              <el-table-column label="规格型号" min-width="95">
                <template v-slot="scope">
                  <el-input
                      v-if="scope.row.isManual"
                      v-model="scope.row.specification"
                      size="small"
                      placeholder="请输入"/>
                  <span v-else>{{scope.row.specification}}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="65" fixed="right">
                <template v-slot="scope">
                  <el-button type="danger" size="mini" @click="handleRemove(scope.$index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Sortable from "sortablejs";
  import ViewTable from "@/components/ViewTable.vue";
  import ColumnConfigTool from "@/components/ColumnConfigTool.vue";

  export default {
    name: "ProductionScheduleList",
    components: {ViewTable, ColumnConfigTool},
    data() {
      return {
        showAside: true,
        showAside1: true,
        scheduleLoading: false,
        submitLoading: false,
        // el-table 实例引用，供 ColumnConfigTool 使用
        elTableRef: null,
        timeCountLoading: false,
        currentDate: this.$moment().format("YYYY-MM-DD"),
        currentLineId: null,
        currentLine: "组装线1",
        lineList: [],
        currentShift: "白班",
        currentShiftId: null,
        shiftList: [],
        currentPersonNum: 3,
        scheduledOrders: [],
        tableHeight: 500,
        remainingCount: 20,
        filter: {
          orders: "",
          materialNo: "",
          materialDescription: "",
          orderType: "",
          orderTypeName: "",
          productStart: this.$moment().format("YYYY-MM-DD"),
          sapCustomerNo: "",
          assemblePlanDate: 0,
          testPlanDate: 0,
          feedPlanDate: 0,
        },
        columnsProperty: [
          { tooltip: true, key: "addDate", align: "center", width: 160 },
          { tooltip: true, key: "productionOrderNo", align: "center", width: 110 },
          { tooltip: true, key: "quantity", align: "center", width: 100 },
          { tooltip: true, key: "saleOrderNo", align: "center", width: 110 },
          { key: "orderTypeName", align: "center", tooltip: true, width: 100 },
          { tooltip: true, key: "materialNo", align: "center", width: 110 },
          { key: "materialDescription", tooltip: true, width: 110 },
          { key: "specification", tooltip: true, width: 110 },
          { key: "productLayer", tooltip: true, width: 110 },
          { tooltip: true, key: "productStart", align: "center", width: 120 },
          { tooltip: true, key: "productEnd", align: "center", width: 120 },
          { tooltip: true, key: "workTime", align: "center", width: 100 },
          { tooltip: true, key: "assemblePlanDate", align: "center", width: 160 },
          { tooltip: true, key: "testPlanDate", align: "center", width: 160 },
          { tooltip: true, key: "feedPlanDate", align: "center", width: 160 },
          { tooltip: true, key: "agingPlanDate", align: "center", width: 160 },
          {
            key: "action",
            width: 100,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },

    watch: {
      scheduleLoading(val) {
        if (!val) {
          this.$nextTick(() => {
            this.createSortable();
          });
        }
      },
    },

    mounted() {
      window.addEventListener("resize", this.calcTableHeight);
      this.$nextTick(() => {
        this.elTableRef = this.$refs.elTable;
        this.createSortable();
        this.loadLineList();
        this.loadShiftList();
        this.syncRemainingCount();
        this.calcTableHeight();
      });
    },

    beforeDestroy() {
      window.removeEventListener("resize", this.calcTableHeight);
      if (this._sortable) {
        this._sortable.destroy();
        this._sortable = null;
      }
    },

    methods: {
      syncRemainingCount(data) {
        if (data) {
          this.remainingCount = data.length;
        } else {
          const viewTable = this.$refs.viewTable;
          if (viewTable && viewTable.tableData) {
            this.remainingCount = viewTable.tableData.length;
          }
        }
      },

      // 加载产线下拉列表（从 MES_ProductionLine 取值）
      loadLineList() {
        this.$http.get("basic", "fm/production-mangeline/list").then(res => {
          if (res.success) {
            this.lineList = res.data || [];
            // 默认选中"组装线1"对应的产线（兼容原有默认），找不到则选第一条
            const defaultLine = this.lineList.find(l => l.lineName === "组装线1") || this.lineList[0];
            if (defaultLine) {
              this.currentLineId = defaultLine.id;
              this.currentLine = defaultLine.lineName;
            }
          }
        });
      },
      // 加载班次模板下拉列表（从 MES_CalendarShift 取值）
      loadShiftList() {
        this.$http.get("basic", "fm/calendarShift/list").then(res => {
          if (res.success) {
            this.shiftList = res.data || [];
            // 默认选中第一个"白班"类型的班次（shiftType=1）
            const first = this.shiftList.find(s => s.shiftType === 1) || this.shiftList[0];
            if (first) {
              this.currentShiftId = first.id;
              this.currentShift = first.shiftName;
            }
            // 班次模板加载完成后再查询排产列表
            this.getData();
          }
        });
      },
      // 切换班次：同步班次名称
      handleShiftChange(val) {
        const item = this.shiftList.find(s => s.id === val);
        this.currentShift = item ? item.shiftName : "";
        this.getData();
      },

      getData() {
        if (!this.currentLine || !this.currentDate) {
          return;
        }
        let param = {
          planDate: this.currentDate,
          productionLine: this.currentLine,
          shift: this.currentShift,
          shiftId: this.currentShiftId,
        };
        this.scheduleLoading = true;
        this.$http.post("basic", "productionOrderScheduled/list", param)
          .then(res => {
            this.scheduledOrders = res.data || [];
            this.scheduledOrders.forEach(o => {
              o.workTime = this.calculateWorkTime(o, o.quantity || 1);
            });
            this.calculateAllOrderTimes();
          }).finally(() => {
            this.scheduleLoading = false;
          });
      },

      // 重置
      handleReset() {
        // 切换产线时，将本地添加（未保存）的工单归还到待排产池
        const tableData = this.$refs.viewTable.tableData;
        this.scheduledOrders.forEach(o => {
          if (o.isFromAdd) {
            const original = o.originalOrder;
            if (!tableData.some(t => t.productionOrderId === original.productionOrderId)) {
              tableData.push(original);
            }
          }
        });
        this.syncRemainingCount();
        this.getData();
      },

      // 刷新工时：根据当前筛选条件重新计算工时，并刷新待排产列表
      handleRefreshTimeCount() {
        this.timeCountLoading = true;
        const svo = { ...this.filter };
        this.$http.post("basic", "productionOrderScheduled/refreshTimeCount", svo)
          .then(res => {
            if (res.success) {
              this.$message.success("工时刷新成功");
              // 刷新左侧待排产工单列表
              this.loadData();
              // 同时刷新右侧排产列表
              this.getData();
            }
          }).finally(() => {
            this.timeCountLoading = false;
          });
      },

      handleCurrentLineChange(val) {
        // 根据产线ID找到对应产线，同步当前产线名称（枚举名）
        const line = this.lineList.find(l => l.id === val);
        this.currentLine = line ? line.lineName : "";
        this.currentPersonNum = this.currentLine && this.currentLine.indexOf("组装") !== -1 ? 2 : 1;
        // 切换产线时，将本地添加（未保存）的工单归还到待排产池
        const tableData = this.$refs.viewTable.tableData;
        this.scheduledOrders.forEach(o => {
          if (o.isFromAdd) {
            const original = o.originalOrder;
            if (!tableData.some(t => t.productionOrderId === original.productionOrderId)) {
              tableData.push(original);
            }
          }
        });
        this.syncRemainingCount();
        this.getData();
      },

      timeToMinutes(timeStr) {
        const [hours, minutes] = timeStr.split(":").map(Number);
        return hours * 60 + minutes;
      },
      minutesToTime(minutes) {
        const hours = Math.floor(minutes / 60);
        const mins = minutes % 60;
        return `${hours.toString().padStart(2, "0")}:${mins.toString().padStart(2, "0")}`;
      },
      calculateBreakTime(startTime, endTime) {
        let breakTime = 0;
        if ((startTime <= this.timeToMinutes("10:00") && endTime >= this.timeToMinutes("10:00"))) breakTime += 10;
        if ((startTime < this.timeToMinutes("13:00") && (endTime + breakTime) > this.timeToMinutes("12:00"))) breakTime += 60;
        if ((startTime <= this.timeToMinutes("15:00") && (endTime + breakTime) >= this.timeToMinutes("15:00"))) breakTime += 10;
        if ((startTime < this.timeToMinutes("18:00") && (endTime + breakTime) > this.timeToMinutes("17:30"))) breakTime += 30;
        return breakTime;
      },
      calculateAllOrderTimes() {
        if (this.scheduledOrders.length === 0) return;
        let currentTime = this.timeToMinutes("08:45");
        this.scheduledOrders.forEach((order) => {
          this.$set(order, "startTime", this.minutesToTime(currentTime));
          const hours = order.workTime / this.currentPersonNum;
          const workTimeMinutes = Math.ceil(hours * 60);
          let endTime = currentTime + workTimeMinutes;
          const breakTime = this.calculateBreakTime(currentTime, endTime);
          endTime += breakTime;
          this.$set(order, "endTime", this.minutesToTime(endTime));
          currentTime = endTime;
        });
      },
      calculateWorkTime(row, qty) {
        const time = this.getTimeByCurrentLine(row.originalOrder);
        return parseFloat((Number(time) / Number(row.originalOrder.quantity)) * qty).toFixed(2);
      },
      // 根据当前产线获取对应的工时字段值
      getTimeByCurrentLine(order) {
        const line = this.currentLine;
        if (line && line.indexOf("组装") !== -1) {
          return order.assembleTime || 0;
        } else if (line === "测试线1") {
          return order.testTime || 0;
        } else if (line === "老化线") {
          return order.agingTime || 0;
        }
        return order.assembleTime || 0;
      },
      // 根据当前产线（工序类型）获取对应工序的"剩余排产数量"
      // 该剩余数量作为默认排产数量的最大值
      getRemainQuantityByCurrentLine(order) {
        const line = this.currentLine;
        let remain = 0;
        if (line && line.indexOf("组装") !== -1) {
          remain = order.assembleRemainQuantity;
        } else if (line === "测试线1") {
          remain = order.testRemainQuantity;
        } else if (line === "老化线") {
          remain = order.agingRemainQuantity;
        } else if (line === "发货前处理线") {
          remain = order.fhqRemainQuantity;
        } else if (line === "生产发料") {
          remain = order.feedRemainQuantity;
        }
        // 没有对应剩余数量时，退回工单数量
        return remain == null ? order.quantity : remain;
      },
      // 数量修改后，按比例换算工时并重算时间
      handleQuantityChange(row) {
        let qty = Number(row.quantity);
        // 排产数量不能超过当前工序的剩余排产数量（上限）
        if (!row.isManual) {
          const maxQuantity = this.getRemainQuantityByCurrentLine(row);
          if (!isNaN(maxQuantity) && Number(maxQuantity) > 0) {
            if (qty > maxQuantity) {
              qty = Number(maxQuantity);
              row.quantity = qty;
              this.$message.warning("排产数量不能超过该工序剩余数量：" + maxQuantity);
            }
          }
        }
        if (isNaN(qty) || qty < 0) {
          qty = 1;
          row.quantity = qty;
        }
        // 手动新增的排产行，修改数量不重新计算工时
        if (!row.isManual) {
          row.workTime = this.calculateWorkTime(row, qty);
        }
        this.calculateAllOrderTimes();
      },
      // 工时输入变更，重新计算开始/结束时间
      handleWorkTimeChange(row) {
        if (Number(row.workTime) < 0) {
          row.workTime = 0;
        }
        this.calculateAllOrderTimes();
      },

      // 仅右侧排产列表内上下拖拽排序，不做跨表拖拽
      createSortable() {
        const table = document.querySelector("#dragTable2 tbody");
        if (!table) return;
        if (this._sortable) {
          this._sortable.destroy();
        }
        this._sortable = Sortable.create(table, {
          // 数量输入框不触发拖拽，但允许正常点击编辑
          filter: ".el-input, .el-select, .el-date-picker",
          preventOnFilter: false,
          onEnd: () => {
            this.calculateAllOrderTimes();
          },
          onUpdate: (evt) => {
            const [removedItem] = this.scheduledOrders.splice(evt.oldIndex, 1);
            this.scheduledOrders.splice(evt.newIndex, 0, removedItem);
          },
        });
      },

      calcTableHeight() {
        const h = window.innerHeight || document.documentElement.clientHeight;
        this.tableHeight = h - 260;
      },

      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
        this.$nextTick(() => {
          this.syncRemainingCount();
        });
      },

      // 手动新增排产行
      handleAddSchedule() {
        const manualRow = {
          productionOrderId: Date.now(),
          isManual: true,
          productionOrderNo: "",
          productLayer: "",
          addDate: "",
          quantity: 1,
          orderType: "",
          orderTypeName: "",
          materialNo: "",
          materialDescription: "",
          specification: "",
          singleAssembleTime: 0,
          workTime: 1,
          startTime: "",
          endTime: "",
          billType:"手动新增",
        };
        this.scheduledOrders.push(manualRow);
        this.calculateAllOrderTimes();
      },

      // 点击"添加"按钮：从待排产 → 排产列表
      addToSchedule(row) {
        // 未计算工时的工单不允许排产，需先手动刷新工时
        if (!row.timeCount) {
          this.$message.warning("该工单尚未计算工时，无法排产，请先手动刷新工时");
          return;
        }
        if (this.scheduledOrders.some(o => o.productionOrderId === row.productionOrderId)) {
          this.$message.error("订单已存在排产列表中");
          return;
        }
        // 保存原始 row 数据，用于后续从排产列表删除时还原到待排产池
        const originalOrder = { ...row };
        // 根据当前排产产线（工序类型），将对应工序的"剩余排产数量"作为默认排产数量
        const remainQuantity = this.getRemainQuantityByCurrentLine(row);
        this.scheduledOrders.push({
          ...row,
          workTime: row.assembleTime,
          orderNumber: row.quantity,
          quantity: remainQuantity,
          originalOrder,
          isFromAdd: true, // 是否通过左侧添加保存到右侧的
          billType:"生产订单",
        });
        // 从待排产本地缓存中移除
        const tableData = this.$refs.viewTable.tableData;
        const idx = tableData.findIndex(o => o.productionOrderId === row.productionOrderId);
        if (idx !== -1) {
          tableData.splice(idx, 1);
        }
        this.syncRemainingCount();
        this.calculateAllOrderTimes();
      },

      getSummaries({columns, data}) {
        const sums = [];
        sums[0] = this.currentLine + "总工时";
        const workTimeIndex = columns.findIndex(col => col.label === "工时");
        if (workTimeIndex !== -1) {
          const values = data.map(item => Number(item.workTime));
          if (!values.every(v => isNaN(v))) {
            sums[workTimeIndex] = values.reduce((p, c) => p + (Number(c) || 0), 0).toFixed(2) + " 小时";
          }
        }
        return sums;
      },

      handleCollapse() {
        this.showAside = !this.showAside;
      },
      handleCollapse1() {
        this.showAside1 = !this.showAside1;
      },
      handleRemove(index) {
        const [removed] = this.scheduledOrders.splice(index, 1);
        // 手动添加的行不需要归还到待排产池
        if (removed && !removed.isManual) {
          const restoredRow = removed.originalOrder;
          const tableData = this.$refs.viewTable.tableData;
          if (!tableData.some(o => o.productionOrderId === restoredRow.productionOrderId)) {
            tableData.push(restoredRow);
          }
        }
        this.syncRemainingCount();
        this.calculateAllOrderTimes();
      },
      handleSave() {
        if (!this.currentLine || !this.currentDate) {
          this.$message.error("请选择排产日期及排产产线");
          return;
        }
        this.submitLoading = true;
        // 去掉临时字段，保存后即为接口数据，切换产线时不再归还待排产
        const cleanOrderList = this.scheduledOrders.map(o => {
          const clean = { ...o };
          delete clean.isFromAdd;
          delete clean.isManual;
          delete clean.originalOrder;
          delete clean.singleAssembleTime;
          return clean;
        });
        let body = {
          orderList: cleanOrderList,
          planDate: this.currentDate,
          shift: this.currentShift,
          shiftId: this.currentShiftId,
          processPersonNum: this.currentPersonNum,
          productionLine: this.currentLine,
          productionLineId: this.currentLineId,
        };
        this.$http.post("basic", "productionOrderScheduled", body)
          .then((res) => {
            if (res.success) {
              this.$message.success("计划保存成功");
              this.getData();
              // 保存成功后，根据当前搜索条件刷新左侧待排产列表
              this.loadData();
            }
          }).finally(() => {
            this.submitLoading = false;
          });
      },

      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },
    },
  };
</script>

<style scoped lang="scss">
.app-container {
  margin: 0 auto;
}
.main-content {
  display: flex;
  height: calc(100% - 80px);
}
.work-order-list {
  flex: 1;
  border-radius: 4px;
  padding: 0 5px;
  display: flex;
  flex-direction: column;
  width: 52%;
  &:not(:first-child) {
    width: calc(48% - 38px);
  }
}
.schedule-date-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 5px;
}
.date-navigation {
  display: flex;
  align-items: center;
  gap: 10px;
}
.schedule-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}
.add-schedule-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 5px 0;
}
.add-schedule-row .column-config-tool {
  margin-left: auto;
}
.section-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 15px;
  color: #303133;
  display: flex;
  align-items: center;
}
.app-container{
  padding: 15px 12px!important;
}
.remaining-count {
  color: #f56c6c;
  font-weight: bold;
  font-size: 14px;
  margin-left: 10px;
}
.work-order-right-box{
  ::v-deep .el-table__footer-wrapper{
    z-index: 2;
  }
  ::v-deep .el-table__fixed-footer-wrapper{
    z-index: 4;
  }
  ::v-deep .el-table-fixed-column--right .el-table__body-wrapper{
    z-index: 1;
  }
}
// 修复 clearable 图标溢出
::v-deep .el-form-item {
  position: relative;
  flex-shrink: 0;
  .el-input {
    overflow: hidden;
  }
  .el-input__suffix {
    right: 5px;
  }
}
// 紧凑搜索框 - 作用于 view-table 内部的搜索区
::v-deep .viewTable .el-form .el-input__inner {
  width: 110px !important;
}
::v-deep .viewTable .el-form .el-date-editor.el-input,
::v-deep .viewTable .el-form .el-date-editor.el-input__inner {
  width: 130px !important;
}
::v-deep .viewTable .el-form .el-select .el-input__inner {
  width: 100px !important;
}
</style>
